<ion-content [scrollEvents]="false">
  <div class="tab-modal" *ngIf="!isLoading && isShowTabModal">
    <div class="tab-modal__backdrop"></div>
    <div class="tab-modal-container">
      <div class="tab-modal-container__content">
        <div class="tab-modal-container__content-title">{{tabModalInfo.title}}</div>
        <div class="tab-modal-container__content-text">{{tabModalInfo.text}}
          <span class="tab-modal-container__content-text-colored">{{tabModalInfo.coloredText}}</span>
        </div>
      </div>
      <div class="tab-modal-container__footer">
        <button class="tab-modal-container__footer-button" (click)="redirectButtonClick()">{{tabModalInfo.buttonText}}</button>
      </div>
    </div>
  </div>
  <div class="spinner-wrapper" *ngIf="isLoading">
    <app-spinner></app-spinner>
  </div>
</ion-content>
